import { render, staticRenderFns } from "./FeatureSelection.vue?vue&type=template&id=8d8ae5da&scoped=true&"
import script from "./FeatureSelection.vue?vue&type=script&lang=js&"
export * from "./FeatureSelection.vue?vue&type=script&lang=js&"
import style0 from "./FeatureSelection.vue?vue&type=style&index=0&id=8d8ae5da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8ae5da",
  null
  
)

export default component.exports